module.exports = __webpack_public_path__ + "b3a5684330b63e46c8bc98660fb62e3f.pdf";